import type { RouteLocationNormalized } from "vue-router";
import { UrlHelper } from "@/common/helper/url-helper-service";

/** Routes and URL contexts that do not require an authenticated session. */
export function isAnonymousAccess(
  to: Pick<RouteLocationNormalized, "meta" | "matched">,
): boolean {
  if (to.meta.public === true) {
    return true;
  }
  return UrlHelper.isAuthVerificationURL();
}
